export const Size = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  XSMALL: 'xsmall'
}

export const SIZE_MAP = {
  xlarge: 'xl',
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  xl: 'xl',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
}

export const DEVICE_SIZES = [
  'xl',
  'lg',
  'md',
  'sm',
  'xs'
]

export const State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
}

export const Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse',
  ARROW_RIGHT: 'arrow-right',
  ARROW_LEFT: 'arrow-left'
}



// WEBPACK FOOTER //
// ./utils/StyleConfig.jsx